import { makeStyles, tokens } from '@fluentui/react-components';

export const useLineCardPricingSectionStyles = makeStyles({
    root: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        width: '100%',
        height: '45px',
        alignContent: 'center',
        '@media screen and (max-width: 480px)': {
            gridTemplateColumns: '1fr 1fr'
        }
    },
    pricingSectionRoot: {
        display: 'flex',
        flexDirection: 'column',
        '@media screen and (max-width: 480px)': {
            rowGap: tokens.spacingVerticalM
        }
    },
    editLink: {
        marginTop: tokens.spacingVerticalL,
        color: tokens.colorBrandForegroundLink
    },
    addDeviceButtons: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        columnGap: tokens.spacingHorizontalL,
        marginTop: tokens.spacingVerticalS
    },
    shopDevicesButton: {
        height: '35px'
    },
    byodButton: {
        height: '35px'
    },
    addPlanButtonWrapper: {
        marginBottom: tokens.spacingVerticalS
    }
});
